// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36el_","type":"styles_type__3xURr","choices":"styles_choices__39A3F"};